module.exports = __webpack_public_path__ + "static/img/drone_03.95053fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/drone_03.jpg
// module id = ijWL
// module chunks = 0